export default "__VITE_ASSET__Z_esQhek__"